// The filter panel's checkbox glyph (#11426 board-toolbar walkthrough,
// wave 2 — CD: "the checkbox glyphs are square and hard-edged against a
// system that rounds everything. Take them to the DS control radius").
// One drawn control for the value rows and the presence rows, replacing
// the phosphor CheckSquare/Square pair and the app-global selection blue:
// on a token surface state is ink, not a colour wash — checked is the ink
// fill with the surface check, the same move as the applied-count pill.

import React from "react";
import { CheckIcon, MinusIcon } from "@phosphor-icons/react";

// `mixed` is the hierarchical list's third state — a branch with only some
// of its descendants selected (#11846, item 11). It fills like checked and
// carries a bar instead of a check, the same ink-not-blue move.
const FilterCheck: React.FC<{ checked: boolean; mixed?: boolean }> = ({
  checked,
  mixed = false,
}) => {
  const filled = checked || mixed;
  return (
    <span
      aria-hidden
      data-filter-check={checked ? "true" : mixed ? "mixed" : undefined}
      className="flex-shrink-0 inline-grid place-items-center"
      style={{
        width: "15px",
        height: "15px",
        borderRadius: "5px",
        border: filled
          ? "1px solid var(--fp-ink)"
          : "1px solid var(--fp-border-strong)",
        background: filled ? "var(--fp-ink)" : "var(--fp-surface)",
        color: "var(--fp-surface)",
        transition: "background 100ms ease-out, border-color 100ms ease-out",
      }}
    >
      {checked ? (
        <CheckIcon size={10} weight="bold" />
      ) : mixed ? (
        <MinusIcon size={10} weight="bold" />
      ) : null}
    </span>
  );
};

export default FilterCheck;
